var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"toggler",staticClass:"navbar-toggler",attrs:{"type":"button","data-bs-toggle":"collapse","aria-expanded":"false","aria-label":"Toggle navigation"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{class:{ open: _vm.clicked },attrs:{"id":"hamburger-icon"}},[_c('span'),_c('span'),_c('span')])])
}
var staticRenderFns = []

export { render, staticRenderFns }